import LoanTasksUtility from "./LoanTasksUtility";
import LoanScopeDataHolder from "../data/model/LoanScopeDataHolder";
import ActivityNavigator, { Activities } from "./ActivityNavigator";
import { TaskStatus } from "./TaskStatus";

export default {
  getNextTask(allowedCurrentTasks, fetchingFirstTime, redirectionUrlOnStageCompletion) {
    return new Promise(resolve => {
      const currentLoanTaskName = LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";

      if (currentLoanTaskName &&
        (!allowedCurrentTasks || !allowedCurrentTasks.includes(currentLoanTaskName))
      ) {
        LoanScopeDataHolder.setFetchingLoanDetailsFirstTime(false);
        this.nextActivity(currentLoanTaskName);
        resolve({ errorOccurred: false, data: {} });
        return;
      }

      LoanTasksUtility.getNextTask(
        LoanScopeDataHolder.getCurrentLoanTask(),
        LoanScopeDataHolder.getLoanId()
      )
        .then(taskRes => {
          if (taskRes.errorOccurred) {
            resolve(taskRes);
          } else {
            if (redirectionUrlOnStageCompletion) {
              LoanScopeDataHolder.setFetchingLoanDetailsFirstTime(false);
              LoanScopeDataHolder.setCurrentLoanTask(null);
              window.location = redirectionUrlOnStageCompletion;
              resolve({ errorOccurred: false, data: {} });
              return;
            }
            const nextTask = taskRes.data;
            if (nextTask) {
              LoanScopeDataHolder.setFetchingLoanDetailsFirstTime(false);
              if (nextTask.task_status === TaskStatus.WAIT) {
                if (!LoanScopeDataHolder.isWaiting()) {
                  this.nextActivity(Activities.WAIT);
                }
              } else {
                LoanScopeDataHolder.setCurrentLoanTask(nextTask);
                LoanScopeDataHolder.setWaiting(false);
                this.nextActivity(nextTask.name);
              }
              resolve(taskRes);
            } else {
              if (fetchingFirstTime) {
                if (!LoanScopeDataHolder.isWaiting()) {
                  this.nextActivity(Activities.WAIT);
                }
                resolve(taskRes);
              } else {
                LoanScopeDataHolder.setFetchingLoanDetailsFirstTime(false);
                LoanTasksUtility.doesNeedToWait(LoanScopeDataHolder.getLoanId())
                  .then(needToWaitRes => {
                    const needToWaitData = needToWaitRes.data ? needToWaitRes.data : {};
                    if (needToWaitData.needToWait) {
                      if (!LoanScopeDataHolder.isWaiting()) {
                        this.nextActivity(Activities.WAIT);
                      }
                    } else {
                      this.nextActivity(Activities.LOAN_DETAILS);
                    }
                    resolve(taskRes);
                  })
              }
            }
          }
        })
    })
  },

  nextActivity(activity) {
    const navigated = ActivityNavigator.navigateTo(activity);
    if (!navigated) {
      LoanScopeDataHolder.setCurrentLoanTask(null);
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    }
  }
};
